// extracted by mini-css-extract-plugin
export default {"reduce":"styles_reduce__bbnF+","list":"styles_list__GL3yr","icon":"styles_icon__oVo8q","strike":"styles_strike__TEbmW","brsp":"styles_brsp__t8wS3"};